<template lang="pug">
    model-form( 
        loading-text="Cargando ticket de venta..."
        ref="form"
        title="Datos del ticket de venta"
        no-buttons
        variant="tabs"
        v-bind="formProps"
        v-model="formData"
    )
</template>

<script>
//
import { mapActions } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import Translator from '@/services/translator'
//
import PosSaleModel from '@/models/POS/PosSale'
import fields from './fields'
//-
export default {
    name: 'sale-ticket-detail',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        /**
         *
         */
        formProps() {
            return {
                busy: this.busy,
                editable: false,
                fields: fields({
                    g_branch_office_id: 1, //TODO: actualizar branch_office Vuex
                    pos_sale_authorizations_length: this.formData.pos_sale_authorizations.length, 
                }),
                loading: this.busy,
                switchEdit: false,
            }
        },
    },
    data() {
        return {
            busy: false,
            formData: {
                pos_sale_authorizations: [],
            },
            loading: true,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        fetch() {
            PosSaleModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        reset() {
            this.fetch()
            this.toggleBusy()
        },

        /**
         *
         */
        setFormData(model) {
            this.busy = false
            this.formData = model.clone().reset()
        },

        /**
         *
         */
        toggleBusy() {
            this.busy = !this.busy
        },
    },
    beforeMount() {
        this.setTitleTopBar('Detalle de ticket de venta')
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_SALE_TICKET')) ctx.$router.push('/')
        })
    },
}
</script>

<style lang="scss"></style>
